import { useEffect, useState } from 'react';

import { getLocalPaymentMethods } from '@services/retryPaymentService';
import { CreditCardBrand } from '@types-internal';
import { AdyenCardBrand, creditCardBrandOfAdyenBrand } from '@types-internal/AdyenTypes';

export default function useSupportedCreditCardBrands(
  siteId: number,
  customerId: string,
  amount: number,
) {
  const [supportedCreditCardBrands, setSupportedCreditCardBrands] = useState<CreditCardBrand[]>([]);

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      const localPaymentMethods = await getLocalPaymentMethods(siteId, customerId, amount);
      if (localPaymentMethods.paymentPartnerConnector === 'ADYEN') {
        const paymentMethod = localPaymentMethods.paymentMethods.find(
          (p) => p.paymentMethod === 'CREDIT_CARD',
        );
        const fetchedSupportedCreditCardBrands: CreditCardBrand[] =
          paymentMethod?.brands?.map(
            (brand) => creditCardBrandOfAdyenBrand[brand as AdyenCardBrand],
          ) ?? [];
        setSupportedCreditCardBrands(fetchedSupportedCreditCardBrands);
      }
    };

    fetchPaymentMethods().catch((error) =>
      console.error('Unable to fetch local payment methods : ', error),
    );
  }, []);

  return supportedCreditCardBrands;
}
